module.exports = __webpack_public_path__ + "img/MAC1110_R.7f225ee5.png";